import React from "react";
import { X } from "lucide-react"; // close icon

const DynamicModal = ({
  showModal,
  handleClose,
  title,
  body,
  size = "md",
  showButtons,
  handleSave,
  primaryText,
  cancleText,
  showPrintButton,
}) => {
  if (!showModal) return null;

  // Tailwind size mapping
  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black bg-opacity-50"
      onClick={handleClose}
    >
      <div
        className={`bg-white rounded-xl shadow-lg w-full ${sizeClasses[size]}`}
        onClick={(e) => e.stopPropagation()} // prevent close on content click
      >
        {/* Header */}
        <div className="flex items-center justify-between border-b p-4">
          <h3 className="text-lg font-semibold">{title}</h3>
          <button
            onClick={handleClose}
            className="text-gray-500 hover:text-gray-700"
          >
            <X size={20} />
          </button>
        </div>

        {/* Body */}
        <div className="p-4 max-h-[calc(100vh-200px)] overflow-y-auto">
          {body}
        </div>

        {/* Footer */}
        {showButtons && (
          <div className="flex justify-end gap-3 border-t p-4">
            <button
              onClick={handleClose}
              className="px-4 py-2 rounded-lg border bg-gray-100 text-gray-700 hover:bg-gray-200"
            >
              {cancleText || "Close"}
            </button>

            {showPrintButton && (
              <button
                onClick={() => window.print()}
                className="px-4 py-2 rounded-lg border bg-blue-100 text-blue-700 hover:bg-blue-200"
              >
                Print
              </button>
            )}

            <button
              onClick={handleSave}
              className="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
            >
              {primaryText || "Save"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DynamicModal;
